import { CustomerSettings } from './branding.model';
import { AddonType } from './products/addon.model';
import { Icons as IconTypeEnum } from './index';

export enum NavigationItemStateEnum {
  WARNING = 'warning'
}

export interface BaseNavigationItem {
  name: string;
  label: string;
  link?: string;
  icon?: IconTypeEnum;
  hide?: boolean;
  hideOnSingleAddonFn?: (addonsType: AddonType[]) => boolean;
  hideOnCustomerSettings?: (settings: CustomerSettings) => boolean;
  redirectLink?: string;
  withPermission?: string;
  notificationCount?: number;
  locked?: boolean;
  state?: NavigationItemStateEnum;
  children?: BaseNavigationItem[];
  exactRouterLinkActive?: boolean;
}
